<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="800">
        <v-card>
            <v-card-title id="heading" class="d-flex justify-space-between">
                <div>
                    <h4>{{ location.name }}'s Zone</h4>
                    <v-btn class="me-3" color="black" size="small" @click="addZoneDialogSwitch = true">
                        Add Zone
                    </v-btn>
                </div>
                <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
            </v-card-title>

            <v-container>
                <v-row>
                    <v-col cols="12">
                        <v-table>
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Created At</th>
                                <th>Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="zone in zones" v-if="!loading && zones" :key="zone.id"
                                class="text-left">
                                <td>{{ zone.name }}</td>
                                <td>{{ types[zone.type].name }}</td>
                                <td>{{ formatDateTime(zone.created_at) }}</td>
                                <td>
                                    <v-btn-group density="compact" divided variant="outlined">
                                        <v-btn class="text-dark" prepend-icon="mdi-plus"
                                               size="x-small" @click="spotListing(zone)">Spot
                                        </v-btn>

                                        <v-btn class="text-warning" prepend-icon="mdi-account-switch"
                                               size="x-small" @click="editZone(zone)">Edit
                                        </v-btn>
                                        <v-btn class="text-error" prepend-icon="mdi-account-multiple-minus"
                                               size="x-small" title="Remove User"
                                               @click="deleteZone(zone)">Remove
                                        </v-btn>
                                    </v-btn-group>
                                </td>
                            </tr>
                            <tr v-else>
                                <td v-if="loading" colspan="5">
                                    <v-progress-circular color="primary" indeterminate/>
                                </td>
                                <td v-else colspan="7">No record found</td>
                            </tr>
                            </tbody>
                        </v-table>
                    </v-col>
                </v-row>

                <v-row v-if="totalPages > 1" justify="center">
                    <v-col cols="8">
                        <v-pagination
                            v-model="currentPage"
                            :length="totalPages"
                            class="my-4"
                            density="compact"
                            @update:model-value="fetchZones"
                        ></v-pagination>
                    </v-col>
                </v-row>
            </v-container>

            <v-card-actions class="px-4 d-flex justify-end">
                <v-btn size="small" type="button"
                       @click="$emit('update:modelValue',false)">
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <Create v-if="addZoneDialogSwitch" v-model="addZoneDialogSwitch"
            :location="location" :types="types" @update-zones="updateZones"/>

    <Edit v-if="EditZoneDialogSwitch" v-model="EditZoneDialogSwitch"
          :types="types" :zone="selectedZone" @update-zone="updateZone"/>

    <Spot v-if="spotsDialogSwitch" v-model="spotsDialogSwitch" :zone="selectedZone"/>


</template>

<script setup>
import {send} from "@/composables/apiClient";
import {ref, reactive, onMounted} from "vue";
import {useSnackbarStore} from "@/stores/snackBarStore";
import Create from "@/components/dialogs/companies/Zones/Create.vue";
import Edit from "@/components/dialogs/companies/Zones/Edit.vue";
import Spot from "@/components/dialogs/companies/Spots/Index.vue";
import {formatDateTime} from "@/composables/useTimezone";

const {showSnackbar} = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    location: Object,
});

const formData = reactive({
    name: null,
});
const emits = defineEmits(['update:modelValue']);
const addZoneDialogSwitch = ref(false);
const EditZoneDialogSwitch = ref(false);
const dialogSwitch = ref(props.modelValue);
const selectedZone = ref(null);
const loading = ref(true);
const totalPages = ref(1);
const currentPage = ref(1);
const zones = ref([]);
const types = ref([
    {id: 0, name: 'Open Parking'},
    {id: 1, name: 'Covered Parking'},
    {id: 2, name: 'Building'},
    {id: 3, name: 'Work Site'},
    {id: 4, name: 'Multi Level Parking'},
    {id: 5, name: 'Single Level Indoor'},
    {id: 6, name: 'Multi Level Indoor'},
]);

const spotsDialogSwitch = ref(false);

onMounted(() => {
    fetchZones();
});

const fetchZones = () => {
    loading.value = true;
    send('get', `companies/locations/${props.location.id}/zones?page=${currentPage.value}`)
        .then((response) => {
            zones.value = response.data.data.zones.data;
            totalPages.value = response.data.data.zones.last_page;
            currentPage.value = response.data.data.zones.current_page;
            loading.value = false;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Zones could not be loaded', 'error')
        })
}

const updateZones = (location) => {
    zones.value.unshift(location);
}
const editZone = (zone) => {
    selectedZone.value = zone;
    EditZoneDialogSwitch.value = true;
}
const updateZone = (updatedZone) => {
    zones.value.map((location, index) => {
        if (location.id === updatedZone.id) {
            zones.value[index] = updatedZone;
        }
    });
}
const deleteZone = (zone) => {
    if (confirm(`Are you sure to remove "${zone.name}" from ${props.location.name}?`)) {
        send('delete', `companies/locations/${props.location.id}/zones/${zone.id}`)
            .then((response) => {
                if (response.data.success) {
                    zones.value.map((item, index) => {
                        if (item.id === zone.id) {
                            zones.value.splice(index, 1);
                        }
                    });
                    showSnackbar(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error)
                showSnackbar(`"${zone.name}" user could not be deleted`, 'error')
            })
    }
}

// show spot listing
const spotListing = (zone) => {
    selectedZone.value = zone;
    spotsDialogSwitch.value = true;
}

</script>
